import React from 'react';

import { useTranslation } from 'react-i18next';

import { useIsUpgradeSuggested } from '~/components/layouts/MainLayout/components/ButtonSuggestion/useButtonSuggestion';
import { IconButton } from '~/design-system/components/IconButton/IconButton';
import {
  DesignSystemIconButtonSize,
  DesignSystemIconButtonVariant,
} from '~/design-system/components/IconButton/utils';
import { Typography } from '~/design-system/components/Typography/Typography';
import { DesignSystemTypography } from '~/design-system/tokens/tokens';
import { getHomePageTitle } from '~/modules/home/constants';

import { HomePageV2AccountDropdown } from '../HomePageV2AccountDropdown';
import { useHomePageV2HeaderActions } from '../hooks/useHomePageV2HeaderActions';
import styles from '../styles.module.scss';

type HomePageV2HeaderMobileProps = {
  onClickOpen: () => void;
};

export const HomePageV2HeaderMobile = ({
  onClickOpen,
}: HomePageV2HeaderMobileProps): JSX.Element => {
  const { t } = useTranslation(['home', 'general']);
  const { handleUpgradeClick, navigateFromHeader } =
    useHomePageV2HeaderActions();
  const isUpgradeSuggested = useIsUpgradeSuggested();

  return (
    <header data-home-v2-header-mobile className={styles.mobile_header}>
      <div className={styles.mobile_header__left}>
        <IconButton
          aria-label={t('v2.sidebar.open_main_menu', 'Open main menu')}
          icon="general/home/24"
          variant={DesignSystemIconButtonVariant.GHOST}
          size={DesignSystemIconButtonSize.LARGE}
          onClick={onClickOpen}
        />
        <Typography variant={DesignSystemTypography.LABEL_2_REGULAR} tag="span">
          {getHomePageTitle(t)}
        </Typography>
      </div>
      <div className={styles.mobile_header__actions}>
        {isUpgradeSuggested && (
          <IconButton
            aria-label={t('general:upgrade', 'Upgrade')}
            icon="general/upgrade/24"
            variant={DesignSystemIconButtonVariant.GHOST}
            size={DesignSystemIconButtonSize.LARGE}
            onClick={handleUpgradeClick}
          />
        )}
        <HomePageV2AccountDropdown
          align="end"
          triggerId="layout-mobile"
          onNavigate={navigateFromHeader}
        />
      </div>
    </header>
  );
};
